import React from 'react';
import {components, type DropdownIndicatorProps} from 'react-select';

import IconChevronDown from '@spothero/icons/chevron-down';

import MotionIcon from 'common/animation/MotionIcon';

const getIconStyleProps = (isOpen: boolean) =>
    ({
        boxSize: 4.5,
        color: 'black',
        animate: {
            rotate: isOpen ? 180 : 0,
        },
        transition: {
            type: 'spring',
            damping: 25,
            stiffness: 180,
            duration: 0.125,
        },
    }) as const;

type CustomDropdownIndicatorProps = DropdownIndicatorProps & {
    selectProps: {
        menuIsOpen: boolean;
    };
};

const MultiselectDropdownIndicator = (props: CustomDropdownIndicatorProps) => {
    const isOpen = props.selectProps.menuIsOpen;

    return (
        <components.DropdownIndicator {...props}>
            <MotionIcon
                name="chevron-down"
                as={IconChevronDown}
                aria-hidden="true"
                {...getIconStyleProps(isOpen)}
            />
        </components.DropdownIndicator>
    );
};

export default MultiselectDropdownIndicator;
